import { render, staticRenderFns } from "./PartCalendar.vue?vue&type=template&id=1a9fa624&"
import script from "./PartCalendar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PartCalendar.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a9fa624')) {
      api.createRecord('1a9fa624', component.options)
    } else {
      api.reload('1a9fa624', component.options)
    }
    module.hot.accept("./PartCalendar.vue?vue&type=template&id=1a9fa624&", function () {
      api.rerender('1a9fa624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/components/WorkplaceOrServiceCalendar/components/PartCalendar.vue"
export default component.exports